export default "__VITE_ASSET__BvMHez2F__"